import React, { lazy, Suspense } from 'react';
import { RecoilRoot } from 'recoil';
import { Routes, Route } from 'react-router-dom';

import { FuegoProvider } from '@nandorojo/swr-firestore';
import { fuego } from '@store/firebase/index';
import Main from './Main';
import '@components/dataEntry/Input/DateInput/day-picker.css';
import GlobalStyle from '@styles/GlobalStyle';

const EmbedCalendarPage = lazy(
  () => import('@pages/Embed/EmbedCalendarPage'),
);

const App = () => {
  return (
    <FuegoProvider fuego={fuego}>
      <GlobalStyle />
      <RecoilRoot>
        <Routes>
          <Route
            path="/embed/calendar/:boardKey"
            element={
              <Suspense fallback={null}>
                <EmbedCalendarPage />
              </Suspense>
            }
          />
          <Route path="*" element={<Main />} />
        </Routes>
      </RecoilRoot>
    </FuegoProvider>
  );
};

export default App;
